/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MaterialDownloadUrlViewModel } from "../types/MaterialDownloadUrlViewModel.ts";

export const materialDownloadUrlViewModelSchema = z.object({
  url: z.string().nullish(),
  expiresAtUtc: z.optional(z.string().datetime()),
}) as unknown as ToZod<MaterialDownloadUrlViewModel>;
